





























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import UrlWrapper from '@/modules/shared/components/shared/UrlWrapper.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import { ContentHeadingResourceModel } from '@/modules/content/models/content-resource.model'
import MarkupTableEmptyRow from '@/modules/common/tes-table/components/shared/MarkupTableEmptyRow.vue'

@Component({
  components: { MarkupTableEmptyRow, SimpleHeader, UrlWrapper, TextEllipsis }
})
export default class ContentLinksTable extends Vue {
  @Prop() headings!: ContentHeadingResourceModel
  @Prop({ default: true }) withHeader !: boolean
  @Prop({ default: 'bg-tes-navy-blue text-tes-white' }) theadClass !: string

  get doesntHaveHeading() {
    return !this.headings ||
      (!this.headings.h1.length && !this.headings.h2.length && !this.headings.h3.length && !this.headings.h4.length)

  }
}
